import { getSupabase } from '../config/configureSupabase';

export const uploadMedia = async (bucket, filePath, fileBlob, contentType = 'image/jpeg') => {
  const supabase = getSupabase();
  if (!supabase) {
    console.warn('[supabaseStorage] Supabase client not initialized');
    return null;
  }

  try {
    const cleanPath = filePath.replace(/^\/+/, '');
    const { data, error } = await supabase.storage
      .from(bucket)
      .upload(cleanPath, fileBlob, {
        upsert: true,
        contentType: contentType,
      });

    if (error) {
      console.warn(`[supabaseStorage] Error uploading to ${bucket}/${cleanPath}:`, error.message);
      return null;
    }

    const { data: publicData } = supabase.storage
      .from(bucket)
      .getPublicUrl(cleanPath);

    return publicData?.publicUrl || null;
  } catch (err) {
    console.warn('[supabaseStorage] Upload exception:', err);
    return null;
  }
};

export const getMediaPublicUrl = (bucket, filePath) => {
  const supabase = getSupabase();
  if (!supabase) return null;
  const cleanPath = filePath.replace(/^\/+/, '');
  const { data } = supabase.storage.from(bucket).getPublicUrl(cleanPath);
  return data?.publicUrl || null;
};
